import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import ReachSlider from './ReachSlider'
import NumberBox from './NumberBox'

export default observer(function ReachFilter() {
  const { search } = useContext(SearchContext)
  const [minReach, setMinReach] = useState(search.min_reach)
  const [maxReach, setMaxReach] = useState(search.max_reach)
  const timeout = useRef(null)

  useEffect(() => {
    setMinReach(search.min_reach)
    setMaxReach(search.max_reach)
  }, [search.min_reach, search.max_reach])

  useEffect(() => () => clearTimeout(timeout.current), [])

  const commit = (min, max) => {
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      search.order = 'reach'
      search.min_reach = min
      search.max_reach = max
    }, 600)
  }

  const onRangeChange = ([min, max]) => {
    setMinReach(min)
    setMaxReach(max)
    commit(min, max)
  }

  return (
    <div className="flex flex-col gap-4">
      <ReachSlider leftValue={1000} rightValue={10_000_000} min={minReach} max={maxReach} onInput={onRangeChange} />
      <div className="flex items-center justify-between gap-4">
        <NumberBox label="Min" value={minReach} onChange={value => { setMinReach(value); commit(value, maxReach) }} />
        <NumberBox label="Max" value={maxReach} onChange={value => { setMaxReach(value); commit(minReach, value) }} />
      </div>
    </div>
  )
})
